import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import { AwardsService } from '../awards/awards.service';
import { SchoolYearLabels, toSchoolYearLabels } from './school-year-tokens';

@Injectable({ providedIn: 'root' })
export class SchoolYearLabelsService {
  private readonly awardsService = inject(AwardsService);
  private labels$: Observable<SchoolYearLabels | null> | undefined;

  public labels(): Observable<SchoolYearLabels | null> {
    this.labels$ ??= this.awardsService.getAcademicYears().pipe(
      map((years) => toSchoolYearLabels(years)),
      catchError(() => {
        this.labels$ = undefined;
        return of(null);
      }),
      shareReplay(1)
    );
    return this.labels$;
  }
}
